import { ContentBlock } from "./components/ContentBlocks";
import { colors } from "../../styles/theme";

export default function GuideRenderer({ guide }) {
  return (
    <div>
      {guide.sections.map((section) => (
        <div
          key={section.id}
          id={`section-${section.id}`}
          style={{ marginBottom: 40 }}
        >
          <h3
            style={{
              fontSize: 20,
              fontWeight: 700,
              marginBottom: 16,
              paddingBottom: 8,
              borderBottom: `2px solid ${colors.border}`,
              color: colors.text,
            }}
          >
            {section.title}
          </h3>
          {section.content.map((block, i) => (
            <ContentBlock key={i} block={block} />
          ))}
        </div>
      ))}
    </div>
  );
}
